<template>
  <div id="app">
    <Goodsinfo />
  </div>
</template>

<script>
import  Goodsinfo from './goodsinfo/goodsinfo.vue'

export default {
  name: 'app',
  components: {
    Goodsinfo
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
